<template>
  <div class="w-full h-full py-[80px] xl:py-[120px]">
    <div class="container">
      <div class="w-full h-full bg-white rounded-xl p-4 md:p-8">
        <h1
          class="text-[28px] md:text-[38px] md:leading-[38px] leading-[28px] font-semibold mb-8"
        >
          {{ $t("landing.saraf_robot_blog") }}
        </h1>
        <Transition name="fade" mode="out-in">
          <div :key="loading">
            <template v-if="loading">
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                <ShimmerBlog v-for="idx of 5" :key="idx" />
              </div>
            </template>
            <template v-else>
              <template v-if="blogList?.length">
                <div
                  class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
                >
                  <BlogCardOutline
                    v-for="(blog, idx) of blogList"
                    :key="idx"
                    :blog="blog"
                  />
                </div>
              </template>
              <template v-else>
                <CommonNoData
                  image="/landing/empty-blog.webp"
                  class="mx-auto"
                  :title="$t('landing.coming_soon')"
                  subtitle=""
                />
              </template>
            </template>
          </div>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ApiService from "@/services/ApiService";
import ShimmerBlog from "@/modules/Landing/components/Shimmer/Blog.vue";
import BlogCardOutline from "@/modules/Landing/components/Blog/CardOutline.vue";
import CommonNoData from "@/modules/Landing/components/Common/NoData.vue";
import { ref, onMounted } from "vue";

const loading = ref(true);
const blogList = ref([]);

onMounted(() => {
  fetchBlogList();
});

const fetchBlogList = () => {
  ApiService.get("landing/blogs/")
    .then((res) => {
      blogList.value = res?.data?.results;
    })
    .finally(() => {
      loading.value = false;
    });
};
</script>

<style scoped></style>
